import React from 'react';

const CodeDFormSection = ({
    canWrite,
    handleAdd,
    handleDSave,
    selectCodeD,
    handleDChange,
    handleDuplD,
    duplDMsg,
    useYnOptions
}) => {
    return (
        <section className="wp25">
            <div className="section-tit-wrap">
                <h3 className="border-left-primary !text-[19px] md:!text-[21px]">&nbsp;공통코드(D) 등록</h3>
                <div className="btn-right-box">
                    <ul>
                        {canWrite && <li><button type="button" title="추가" className="btn-add" id="btn-add01" onClick={() => handleAdd("d")}>추가</button></li>}
                        {canWrite && <li><button type="button" title="저장" className="btn-save" id="btn-save01" onClick={handleDSave}>저장</button></li>}
                    </ul>
                </div>
            </div>

            {/* Mobile: 카드형 폼 */}
            <div className="md:hidden rounded-xl border border-gray-200 bg-white p-4 shadow-sm space-y-4">
                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">그룹코드<span className="red">*</span></label>
                    <input
                        name="comdCode"
                        value={selectCodeD.comhCode || ""}
                        onChange={handleDChange}
                        disabled={true}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px] bg-gray-50"
                    />
                </div>

                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">공통코드<span className="red">*</span></label>
                    <input
                        name="comdCode"
                        value={selectCodeD.comdCode || ""}
                        onChange={handleDChange}
                        className="w-full min-w-0 rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                    />
                    <button
                        type="button"
                        className="btn-search w-full mt-2"
                        onClick={handleDuplD}
                        disabled={selectCodeD.isNew ? false : true}
                    >
                        중복확인
                    </button>
                    {selectCodeD.isNew && (
                        <p className="mt-1 text-[13px] text-gray-600">{duplDMsg || ""}</p>
                    )}
                </div>

                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">공통코드명<span className="red">*</span></label>
                    <input
                        name="comdName"
                        value={selectCodeD.comdName || ""}
                        onChange={handleDChange}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">사용자정의 1</label>
                        <input
                            name="usrDfn1"
                            value={selectCodeD.usrDfn1 || ""}
                            onChange={handleDChange}
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                        />
                    </div>
                    <div>
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">사용자정의 2</label>
                        <input
                            name="usrDfn2"
                            value={selectCodeD.usrDfn2 || ""}
                            onChange={handleDChange}
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                        />
                    </div>
                    <div className="sm:col-span-2">
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">사용자정의 3</label>
                        <input
                            name="usrDfn3"
                            value={selectCodeD.usrDfn3 || ""}
                            onChange={handleDChange}
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">정렬 순서<span className="red">*</span></label>
                        <input
                            name="dsort"
                            value={selectCodeD.dsort || ""}
                            onChange={handleDChange}
                            type="number"
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                        />
                    </div>
                    <div>
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">사용여부<span className="red">*</span></label>
                        <select
                            name="duseYn"
                            value={selectCodeD.duseYn || ""}
                            onChange={handleDChange}
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px] bg-white"
                        >
                            {useYnOptions.map((data) => (
                                <option key={data.key} value={data.key}>{data.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">비고</label>
                    <input
                        name="dnotice"
                        value={selectCodeD.dnotice || ""}
                        onChange={handleDChange}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                    />
                </div>
            </div>

            {/* Desktop: 기존 테이블 */}
            <div className="hidden md:block table-container overflow-x-auto [-webkit-overflow-scrolling:touch]">
                <table className="table-write !text-[15px] md:!text-[16px] lg:!text-[17px]" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '70%' }} />
                    </colgroup>
                    <tbody id="tblBody1">
                        <tr>
                            <th>그룹코드<span className="red">*</span></th>
                            <td>
                                <input
                                    name="comdCode"
                                    value={selectCodeD.comhCode || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none', backgroundColor: '#f8f9fa' }}
                                    disabled={true}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>공통코드<span className="red">*</span></th>
                            <td>
                                <div className="flex flex-col xl:flex-row gap-2">
                                    <input
                                        name="comdCode"
                                        value={selectCodeD.comdCode || ""}
                                        onChange={handleDChange}
                                        className="input-search"
                                        style={{ width: '100%', maxWidth: 'none' }}
                                    />
                                    <button type="button" className="btn-search" id="duplCodeH"
                                        onClick={handleDuplD} disabled={selectCodeD.isNew ? false : true}>중복확인</button>
                                </div>
                                <label style={{ display: selectCodeD.isNew ? "" : "none" }}>{duplDMsg || ""}</label>
                            </td>
                        </tr>
                        <tr>
                            <th>공통코드명<span className="red">*</span></th>
                            <td>
                                <input
                                    name="comdName"
                                    value={selectCodeD.comdName || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>사용자정의 1</th>
                            <td>
                                <input
                                    name="usrDfn1"
                                    value={selectCodeD.usrDfn1 || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>사용자정의 2</th>
                            <td>
                                <input
                                    name="usrDfn2"
                                    value={selectCodeD.usrDfn2 || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>사용자정의 3</th>
                            <td>
                                <input
                                    name="usrDfn3"
                                    value={selectCodeD.usrDfn3 || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>비고</th>
                            <td>
                                <input
                                    name="dnotice"
                                    value={selectCodeD.dnotice || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>정렬 순서<span className="red">*</span></th>
                            <td>
                                <input
                                    name="dsort"
                                    value={selectCodeD.dsort || ""}
                                    onChange={handleDChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                    type="number"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>사용여부<span className="red">*</span></th>
                            <td>
                                <select
                                    name="duseYn"
                                    value={selectCodeD.duseYn || ""}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                    onChange={handleDChange}
                                >
                                    {useYnOptions.map((data) => (
                                        <option key={data.key} value={data.key}>{data.name}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default CodeDFormSection;
